import { Component, ViewChild, OnInit, Output, EventEmitter }   from '@angular/core';
import { ModalDirective }                                       from 'ng2-bootstrap/modal';
import { RoleService}                                            from '../../services/role.service';
import { Role }                                                  from '../../models/role';
import { Subject }                                              from 'rxjs/Subject';
import { UserService }                                          from '../../services/user.service';
import { User }                                                 from '../../models/user';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'assign-role',
  templateUrl: './assign-role.component.html',
  styleUrls: ["assign-role.component.scss"]
})

export class AssignRoleComponent implements OnInit {

  private id: string;
  private name: string;

  @ViewChild('modal') modal: ModalDirective;
  @Output() userEdited = new EventEmitter();

  private roles: any[] = [];
  private user: User;
  private selectedRoles: any[];

  constructor(private roleService: RoleService, private userService: UserService) { }

  ngOnInit(): void {
    this
      .roleService
      .getRoles()
      .subscribe(roles => {
        this.roles = roles.map(role => { return { "id": role.id, "text": role.name }; });
      })
  }

  show(id: string): void {
    this
      .userService
      .getUser(id)
      .subscribe(user => {
        this.user = user;
        this.selectedRoles = this.user.roles.map(id => this.roles.find(role => role.id == id));
      });
    this.modal.show();
  }

  setRoles(roles) {
    this.selectedRoles = roles;
  }


  updateRoles(id: string, roles: any[], user): void {
    user.roles = roles.map(role => role.id);
    this.userService.update(user).subscribe(() => {
      this.userEdited.emit(user);
      this.modal.hide()
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/users/components/assign-role/assign-role.component.ts